import {combineReducers} from 'redux';
import * as userReducers from './user';
import * as routesReducers from './routes';

export default combineReducers(Object.assign(
    userReducers,
    routesReducers
));
